import { render } from "./card-work.vue?vue&type=template&id=a98dd906&scoped=true"
import script from "./card-work.vue?vue&type=script&lang=js"
export * from "./card-work.vue?vue&type=script&lang=js"

import "./card-work.vue?vue&type=style&index=0&id=a98dd906&lang=scss&scoped=true"

import exportComponent from "/home/mark/Dev/www/Portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98dd906"]])

export default __exports__